import { AxiosResponse } from 'axios';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  Configuration,
  ApplicationsV1Api,
  ApplicationOccupantDto,
  CreateApplicationOccupantDto,
  UpdateApplicationOccupantDto,
  CreateApplicationPetDto,
  UpdateApplicationPetDto,
  ApplicationPetDto,
  ApplicationTsCsDto,
  LegalApi,
  ApplicationSearchResponseDto,
  ApplicationSearchDto,
  ApplicationDto,
  InvitedApplicationBasicDto,
  InviteCoapplicantDto,
  ApplicationDesiredFileDto,
  ApplicationVehicleDto,
  CreateApplicationVehicleDto,
  UpdateApplicationVehicleDto,
  CreateApplicationEmploymentDto,
  UpdateApplicationEmploymentDto,
  CreateApplicationRentalHistoryDto,
  UpdateApplicationRentalHistoryDto,
  ApplicationRentalHistoryDto,
  ApplicationEmploymentDto,
  CreateScreeningOrderDto,
  ScreeningOrderDto,
  ApplicationV2Dto,
  ApplicationsV2Api,
  ApplicationDecisionFileExportDto,
  ApplicationSearchResponseV3Dto,
  CreateApplicationNoteDto,
  ApplicationNoteDto,
  DocumentsApi,
  UpdateApplicationPropertyDto,
  SendApplicationStatusNotificationDto,
  ChangeApplicationStatusDto,
} from '@inosio/payments-sdk';
import {
  getFetchingApplicationsData,
  setFetchingApplicationsData,
  getFetchingApplicationsDataFailed,
  getApplicant,
  handleGetApplicantSuccess,
  handleGetApplicantFailed,
  createApplicant,
  handleCreateApplicantSuccess,
  handleCreateApplicantFailed,
  updateApplicant,
  handleUpdateApplicantSuccess,
  handleUpdateApplicantFailed,
  deleteApplicant,
  handleDeleteApplicantSuccess,
  handleDeleteApplicantFailed,
  createPet,
  handleCreatePetSuccess,
  handleCreatePetFailed,
  updatePet,
  handleUpdatePetSuccess,
  handleUpdatePetFailed,
  deletePet,
  handleDeletePetSuccess,
  handleDeletePetFailed,
  createVehicle,
  handleCreateVehicleSuccess,
  handleCreateVehicleFailed,
  updateVehicle,
  handleUpdateVehicleSuccess,
  handleUpdateVehicleFailed,
  deleteVehicle,
  handleDeleteVehicleSuccess,
  handleDeleteVehicleFailed,
  createEmployment,
  handleCreateEmploymentSuccess,
  handleCreateEmploymentFailed,
  updateEmployment,
  handleUpdateEmploymentSuccess,
  handleUpdateEmploymentFailed,
  deleteEmployment,
  handleDeleteEmploymentSuccess,
  handleDeleteEmploymentFailed,
  createRentalHistory,
  handleCreateRentalHistorySuccess,
  handleCreateRentalHistoryFailed,
  updateRentalHistory,
  handleUpdateRentalHistorySuccess,
  handleUpdateRentalHistoryFailed,
  deleteRentalHistory,
  handleDeleteRentalHistorySuccess,
  handleDeleteRentalHistoryFailed,
  getInvitedApplication,
  handleGetInvitedApplicationSuccess,
  handleGetInvitedApplicationFailed,
  getCompanyContract,
  handleGetOrganizationContractSuccess,
  handleGetContractFailed,
  getExportApplicationDetails,
  setExportApplicationDetails,
  setExportApplicationDetailsError,
  sendCoapplicantInvitation,
  handleSendingInvitationSuccess,
  handleSendingInvitationFailed,
  handleCreateScreeningOrderSuccess,
  handleCreateScreeningOrderFailed,
  createScreeningOrder,
  handleGetScreeningOrderDetailsSuccess,
  handleGetScreeningOrderDetailsFailed,
  getScreeningOrderDetails,
  getFetchingApplicationsDataV2,
  setFetchingApplicationsDataV2,
  getFetchingApplicationsDataV2Failed,
  getApplicationSuccess,
  getApplicationFailed,
  getApplication,
  setApplicationPdfUrl,
  getExportApplicationPdf,
  handleSendApplicationDecisionNotificationSuccess,
  handleSendApplicationDecisionNotificationFailed,
  sendApplicationDecisionNotification,
  downloadApplicationDecisionPdf,
  handleDownloadApplicationDecisionPdfSuccess,
  handleDownloadingApplicationDecisionPdfFailure,
  handleChangeAppStatusSuccess,
  handleChangeAppStatusFailed,
  changeApplicationStatus,
  setExportEmploymentRelease,
  setExportEmploymentReleaseError,
  setExportRentalRelease,
  setExportRentalReleaseError,
  exportEmploymentRelease,
  exportRentalRelease,
  setEmploymentReleaseURL,
  setEmploymentReleaseURLError,
  setRentalHistoryReleaseURL,
  fetchEmploymentReleaseURL,
  fetchRentalHistoryReleaseURL,
  setRentalHistoryURLReleaseURLError,
  setApplicationPdfUrlError,
  createApplicationNote,
  setApplicationNote,
  setErrorCreateApplicationNote,
  getAllApplicationNotes,
  setAllApplicationNotes,
  setErrorFetchAllApplicationNotes,
  deleteApplicationNote,
  setDeleteApplicationNote,
  setErrorDeleteApplicationNote,
  setApplicantAttachmentUrl,
  setErrorApplicantAttachmentUrl,
  fetchApplicantAttachmentUrl,
  downloadApplicantAttachment,
  setDownloadApplicantAttachment,
  setErrorDownloadApplicantAttachment,
  updateApplicationProperty,
  setUpdateApplicationProperty,
  setErrorUpdateApplicationProperty,
  setExportApplicationZip,
  setErrorExportApplicationZip,
  exportApplicationZip,
} from './applicationsSlice';
import { IpaUserExtended, selectCurrentUser } from '../../../../shared/sagas/auth/authSlice';
import { Stream } from 'stream';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestUpdateApplicationProperty(accessToken: string, applicationUuid: string, updateApplicationPropertyDto: UpdateApplicationPropertyDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.updateApplicationProperty(applicationUuid, updateApplicationPropertyDto);
}

export function requestDownloadApplicantAttachment(accessToken: string, remoteuuid: string, fileType: string, viewInBrowser?: boolean) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });
  const ipaDocumentsApi = new DocumentsApi(apiConfig);
  const responseType = 'arraybuffer';
  const contentDisposition = fileType;
  const headerParams = {
    'Content-Disposition': contentDisposition,
  };
  return ipaDocumentsApi.getDocumentFile(remoteuuid, undefined, viewInBrowser, { responseType, headers: headerParams });
}

export function requestGetAllApplicationNotes(accessToken: string, applicationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.getAllNotes(applicationUuid);
}

export function requestDeleteApplicationNote(accessToken: string, applicationUuid: string, noteId: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.deleteNote(applicationUuid, noteId);
}

export function requestCreateApplicationNote(accessToken: string, applicationUuid: string, createApplicationNoteDto: CreateApplicationNoteDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.createNote(applicationUuid, createApplicationNoteDto);
}

export function requestDownloadApplicationDecisionPdf(access_token: string, appUuid: string, applicationDecisionFileExportDto: ApplicationDecisionFileExportDto) {
  apiConfig.accessToken = access_token;

  const responseType = 'arraybuffer';
  const contentDisposition = 'application/pdf';
  const headerParams = {
    'Content-Disposition': contentDisposition,
  };

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.exportApplicationDecisionFiles(appUuid, applicationDecisionFileExportDto, { responseType, headers: headerParams });
}

export function requestSendApplicationStatusNotification(accessToken: string, applicationUuid: string, sendApplicationStatusNotificationDto: SendApplicationStatusNotificationDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.sendApplicationStatusNotification(applicationUuid, sendApplicationStatusNotificationDto);
}

export function requestFetchingApplicationsData(access_token: string, appSearchDto: ApplicationSearchDto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.searchApplications(appSearchDto);
}

export function requestFetchingApplicationsDataV2(access_token: string, appSearchDto: ApplicationSearchDto) {
  apiConfig.accessToken = access_token;
  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.searchApplicationsV2(appSearchDto);
}

export function requestChangeApplicationStatus(accessToken: string, applicationUuid: string, changeApplicationStatusDto: ChangeApplicationStatusDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.changeApplicationStatus(applicationUuid, changeApplicationStatusDto);
}

export function requestGetApplicant(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.getApplicant(applicantUuid);
}

export function requestGetApplication(accessToken: string, applicationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsV2API = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsV2API.getApplicationV2(applicationUuid);
}

export function requestCreateApplicant(accessToken: string, createApplicantDto: CreateApplicationOccupantDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createApplicant(createApplicantDto);
}

export function requestUpdateApplicant(accessToken: string, applicantUuid: string, updateApplicantDto: UpdateApplicationOccupantDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.updateApplicant(applicantUuid, updateApplicantDto);
}

export function requestDeleteApplicant(accessToken: string, applicantUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.deleteApplicant(applicantUuid);
}

export function requestCreatePet(accessToken: string, createPetDto: CreateApplicationPetDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createPet(createPetDto);
}

export function requestUpdatePet(accessToken: string, PetUuid: string, updatePetDto: UpdateApplicationPetDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.updatePet(PetUuid, updatePetDto);
}

export function requestDeletePet(accessToken: string, PetUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.deletePet(PetUuid);
}

export function requestCreateVehicle(accessToken: string, createVehicleDto: CreateApplicationVehicleDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createVehicle(createVehicleDto);
}

export function requestUpdateVehicle(accessToken: string, VehicleUuid: string, updateVehicleDto: UpdateApplicationVehicleDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.updateVehicle(VehicleUuid, updateVehicleDto);
}

export function requestDeleteVehicle(accessToken: string, VehicleUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.deleteVehicle(VehicleUuid);
}

export function requestCreateEmployment(accessToken: string, createEmploymentDto: CreateApplicationEmploymentDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createEmployment(createEmploymentDto);
}

export function requestUpdateEmployment(accessToken: string, EmploymentUuid: string, updateEmploymentDto: UpdateApplicationEmploymentDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.updateEmployment(EmploymentUuid, updateEmploymentDto);
}

export function requestDeleteEmployment(accessToken: string, EmploymentUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.deleteEmployment(EmploymentUuid);
}

export function requestCreateRentalHistory(accessToken: string, createRentalHistoryDto: CreateApplicationRentalHistoryDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createRentalHistory(createRentalHistoryDto);
}

export function requestUpdateRentalHistory(accessToken: string, RentalHistoryUuid: string, updateRentalHistoryDto: UpdateApplicationRentalHistoryDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.updateRentalHistory(RentalHistoryUuid, updateRentalHistoryDto);
}

export function requestDeleteRentalHistory(accessToken: string, RentalHistoryUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.deleteRentalHistory(RentalHistoryUuid);
}

export function requestGetInvitedApplication(application: string, coapplicant: string, hmac: string) {
  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.getApplicationDetail(application, coapplicant, hmac);
}

export function requestInosioApplicationContract() {
  const ipaLegalApi = new LegalApi(apiConfig);

  return ipaLegalApi.getInosioPmTermsConditions();
}

export function requestOrganizationApplicationContract(accessToken: string, organizationUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.getOrganizationApplicationTerms(organizationUuid);
}

export function requestGetScreeningOrderDetails(accessToken: string, screeningOrderUuid: string) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.getScreeningOrderDetails(screeningOrderUuid);
}

export function requestExportApplicationDetail(access_token: string, appUuid: string, desiredFileDto: ApplicationDesiredFileDto) {
  apiConfig.accessToken = access_token;

  const responseType = 'arraybuffer';
  const contentDisposition = 'application/pdf';
  const headerParams = {
    'Content-Disposition': contentDisposition,
  };

  const ipaApplicationsAPI = new ApplicationsV2Api(apiConfig);
  return ipaApplicationsAPI.exportApplicationFiles(appUuid, desiredFileDto, { responseType, headers: headerParams });
}

export function requestSendCoapplicantInvitation(accessToken: string, applicationUuid: string, inviteDto: InviteCoapplicantDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.inviteCoapplicant(applicationUuid, inviteDto);
}

export function requestCreateScreeningOrder(accessToken: string, createScreeningDto: CreateScreeningOrderDto) {
  apiConfig.accessToken = accessToken;

  const ipaApplicationsAPI = new ApplicationsV1Api(apiConfig);
  return ipaApplicationsAPI.createScreeningOrder(createScreeningDto);
}

export function* handleFetchingApplications(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationSearchResponseDto> = yield call(requestFetchingApplicationsData, currentUser.accessToken, action.payload);
    const { data } = response;

    yield put(setFetchingApplicationsData(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getFetchingApplicationsDataFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getFetchingApplicationsDataFailed({ ...error }));
    }
  }
}

export function* handleFetchingApplicationsV2(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationSearchResponseV3Dto> = yield call(requestFetchingApplicationsDataV2, currentUser.accessToken, action.payload);
    const { data } = response;

    yield put(setFetchingApplicationsDataV2(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getFetchingApplicationsDataV2Failed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getFetchingApplicationsDataV2Failed({ ...error }));
    }
  }
}

export function* handleChangeApplicationStatus(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationDto> = yield call(requestChangeApplicationStatus, currentUser.accessToken, action.payload.applicationUuid, action.payload.changeAppStatusDto);
    const { data } = response;
    yield put(handleChangeAppStatusSuccess(data));
  } catch (error: any) {
    yield put(
      handleChangeAppStatusFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleGetApplication(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationV2Dto> = yield call(requestGetApplication, currentUser.accessToken, action.payload.applicationUuid);
    const { data } = response;
    yield put(getApplicationSuccess(data));
  } catch (error: any) {
    yield put(
      getApplicationFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleGetApplicant(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationOccupantDto> = yield call(requestGetApplicant, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = response;
    yield put(handleGetApplicantSuccess({ data, isGettingCoApplicant: action.payload.isGettingCoApplicant }));
  } catch (error: any) {
    yield put(
      handleGetApplicantFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleCreateApplicant(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationOccupantDto> = yield call(requestCreateApplicant, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreateApplicantSuccess(data));
  } catch (error: any) {
    yield put(
      handleCreateApplicantFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleUpdateApplicant(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationOccupantDto> = yield call(requestUpdateApplicant, currentUser.accessToken, action.payload.applicantUuid, action.payload);
    const { data } = response;
    yield put(handleUpdateApplicantSuccess(data));
  } catch (error: any) {
    yield put(
      handleUpdateApplicantFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeleteApplicant(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeleteApplicant, currentUser.accessToken, action.payload.applicantUuid);
    const { data } = response;
    yield put(handleDeleteApplicantSuccess(data));
  } catch (error: any) {
    yield put(
      handleDeleteApplicantFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleCreatePet(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationPetDto> = yield call(requestCreatePet, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreatePetSuccess(data));
  } catch (error: any) {
    yield put(
      handleCreatePetFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleUpdatePet(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationPetDto> = yield call(requestUpdatePet, currentUser.accessToken, action.payload.petUuid, action.payload);
    const { data } = response;
    yield put(handleUpdatePetSuccess(data));
  } catch (error: any) {
    yield put(
      handleUpdatePetFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeletePet(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeletePet, currentUser.accessToken, action.payload.petUuid);
    const { data } = response;
    yield put(handleDeletePetSuccess(data));
  } catch (error: any) {
    yield put(
      handleDeletePetFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleCreateVehicle(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationVehicleDto> = yield call(requestCreateVehicle, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreateVehicleSuccess(data));
  } catch (error: any) {
    yield put(
      handleCreateVehicleFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleUpdateVehicle(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationVehicleDto> = yield call(requestUpdateVehicle, currentUser.accessToken, action.payload.vehicleUuid, action.payload);
    const { data } = response;
    yield put(handleUpdateVehicleSuccess(data));
  } catch (error: any) {
    yield put(
      handleUpdateVehicleFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeleteVehicle(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeleteVehicle, currentUser.accessToken, action.payload.vehicleUuid);
    const { data } = response;
    yield put(handleDeleteVehicleSuccess(data));
  } catch (error: any) {
    yield put(
      handleDeleteVehicleFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleCreateEmployment(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationEmploymentDto> = yield call(requestCreateEmployment, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreateEmploymentSuccess(data));
  } catch (error: any) {
    yield put(
      handleCreateEmploymentFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleUpdateEmployment(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationEmploymentDto> = yield call(requestUpdateEmployment, currentUser.accessToken, action.payload.EmploymentUuid, action.payload);
    const { data } = response;
    yield put(handleUpdateEmploymentSuccess(data));
  } catch (error: any) {
    yield put(
      handleUpdateEmploymentFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeleteEmployment(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeleteEmployment, currentUser.accessToken, action.payload.EmploymentUuid);
    const { data } = response;
    yield put(handleDeleteEmploymentSuccess(data));
  } catch (error: any) {
    yield put(
      handleDeleteEmploymentFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleCreateRentalHistory(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationRentalHistoryDto> = yield call(requestCreateRentalHistory, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreateRentalHistorySuccess(data));
  } catch (error: any) {
    yield put(
      handleCreateRentalHistoryFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleUpdateRentalHistory(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationRentalHistoryDto> = yield call(requestUpdateRentalHistory, currentUser.accessToken, action.payload.RentalHistoryUuid, action.payload);
    const { data } = response;
    yield put(handleUpdateRentalHistorySuccess(data));
  } catch (error: any) {
    yield put(
      handleUpdateRentalHistoryFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeleteRentalHistory(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestDeleteRentalHistory, currentUser.accessToken, action.payload.RentalHistoryUuid);
    const { data } = response;
    yield put(handleDeleteRentalHistorySuccess(data));
  } catch (error: any) {
    yield put(
      handleDeleteRentalHistoryFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleGetInvitedApplication(action: any) {
  try {
    const response: AxiosResponse<InvitedApplicationBasicDto> = yield call(requestGetInvitedApplication, action.payload.applicationUuid, action.payload.coapplicantUuid, action.payload.hmac);
    const { data } = response;
    yield put(handleGetInvitedApplicationSuccess(data));
  } catch (error: any) {
    yield put(
      handleGetInvitedApplicationFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleGetOrganizationContract(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationTsCsDto> = yield call(requestOrganizationApplicationContract, currentUser.accessToken, action.payload.organizationUuid);
    const { data } = response;
    yield put(handleGetOrganizationContractSuccess(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(handleGetContractFailed({ ...error?.response?.data }));
    } else {
      yield put(handleGetContractFailed({ ...error }));
    }
  }
}

export function* handleExportApplicationDetails(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    // download stream
    let fileName = 'online_application.pdf'; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportApplicationDetails());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setExportApplicationDetailsError({ ...error?.response?.data }));
    } else {
      yield put(setExportApplicationDetailsError({ ...error }));
    }
  }
}

export function* handleExportEmploymentRelease(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    // download stream
    let fileName = 'online_application.pdf'; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportEmploymentRelease());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setExportEmploymentReleaseError({ ...error?.response?.data }));
    } else {
      yield put(setExportEmploymentReleaseError({ ...error }));
    }
  }
}

export function* handleExportRentalRelease(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    // download stream
    let fileName = 'online_application.pdf'; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportRentalRelease());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setExportRentalReleaseError({ ...error?.response?.data }));
    } else {
      yield put(setExportRentalReleaseError({ ...error }));
    }
  }
}

export function* handleExportApplicationPdf(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, { Type: 'ApplicationDetailsPdf' } as ApplicationDesiredFileDto);

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    // Open the document in a new tab
    window.open(url, '_blank');
    yield put(setApplicationPdfUrl());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setApplicationPdfUrlError({ ...error?.response?.data }));
    } else {
      yield put(setApplicationPdfUrlError({ ...error }));
    }
  }
}

export function* handleFetchEmploymentReleaseURL(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    // Open the document in a new tab
    window.open(url, '_blank');
    yield put(setEmploymentReleaseURL());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setEmploymentReleaseURLError({ ...error?.response?.data }));
    } else {
      yield put(setEmploymentReleaseURLError({ ...error }));
    }
  }
}

export function* handleFetchRentalHistoryReleaseURL(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    // Open the document in a new tab
    window.open(url, '_blank');
    yield put(setRentalHistoryReleaseURL());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setRentalHistoryURLReleaseURLError({ ...error?.response?.data }));
    } else {
      yield put(setRentalHistoryURLReleaseURLError({ ...error }));
    }
  }
}

export function* handleSendCoapplicantInvitation(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestSendCoapplicantInvitation, currentUser.accessToken, action.payload.applicationUuid, action.payload.inviteDto);
    const { data } = response;
    yield put(handleSendingInvitationSuccess(data));
  } catch (error: any) {
    yield put(handleSendingInvitationFailed({ message: error?.response?.data?.message, statusCode: error?.response?.data?.statusCode }));
  }
}

export function* handleCreateScreeningOrder(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ScreeningOrderDto> = yield call(requestCreateScreeningOrder, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(handleCreateScreeningOrderSuccess(data));
  } catch (error: any) {
    yield put(
      handleCreateScreeningOrderFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleGetScreeningDetails(action: { payload: { screeningOrderUuid: string }; type: string }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ScreeningOrderDto> = yield call(requestGetScreeningOrderDetails, currentUser.accessToken, action.payload.screeningOrderUuid);
    const { data } = response;
    yield put(handleGetScreeningOrderDetailsSuccess(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(handleGetScreeningOrderDetailsFailed({ ...error?.response?.data }));
    } else {
      yield put(handleGetScreeningOrderDetailsFailed({ ...error }));
    }
  }
}

export function* handleSendApplicationStatusNotification(action: {
  type: typeof sendApplicationDecisionNotification.type;
  payload: { applicationUuid: string; sendApplicationStatusNotificationDto: SendApplicationStatusNotificationDto };
}) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestSendApplicationStatusNotification, currentUser.accessToken, action.payload.applicationUuid, action.payload.sendApplicationStatusNotificationDto);
    yield put(handleSendApplicationDecisionNotificationSuccess());
  } catch (error: any) {
    yield put(
      handleSendApplicationDecisionNotificationFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDownloadApplicationDecisionPdf(action: {
  type: typeof downloadApplicationDecisionPdf.type;
  payload: { applicationUuid: string; applicationDecisionFileExportDto: ApplicationDecisionFileExportDto };
}) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestDownloadApplicationDecisionPdf, currentUser.accessToken, action.payload.applicationUuid, action.payload.applicationDecisionFileExportDto);

    let fileName = 'Adverse_Action_Notice.pdf'; // just a fallback, actual file name comes from the API
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }
    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    yield put(handleDownloadApplicationDecisionPdfSuccess());
  } catch (error: any) {
    yield put(
      handleDownloadingApplicationDecisionPdfFailure({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleCreateApplicationNote(action: { type: typeof createApplicationNote.type; payload: { applicationUuid: string; createApplicationNoteDto: CreateApplicationNoteDto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationNoteDto> = yield call(requestCreateApplicationNote, currentUser.accessToken, action.payload.applicationUuid, action.payload.createApplicationNoteDto);
    const { data } = response;
    yield put(setApplicationNote(data));
  } catch (error: any) {
    yield put(
      setErrorCreateApplicationNote({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleGetAllApplicationNotes(action: { type: typeof getAllApplicationNotes.type; payload: { applicationUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<ApplicationNoteDto[]> = yield call(requestGetAllApplicationNotes, currentUser.accessToken, action.payload.applicationUuid);
    const { data } = response;
    yield put(setAllApplicationNotes(data));
  } catch (error: any) {
    yield put(
      setErrorFetchAllApplicationNotes({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleDeleteApplicationNote(action: { type: typeof deleteApplicationNote.type; payload: { applicationUuid: string; noteId: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestDeleteApplicationNote, currentUser.accessToken, action.payload.applicationUuid, action.payload.noteId);
    yield put(setDeleteApplicationNote());
  } catch (error: any) {
    yield put(
      setErrorDeleteApplicationNote({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleFetchApplicantAttachmentUrl(action: { type: typeof fetchApplicantAttachmentUrl; payload: { remoteUuid: string; fileType: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestDownloadApplicantAttachment, currentUser.accessToken, action.payload.remoteUuid, action.payload.fileType, true);

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: response.headers['content-type'] }));
    yield put(setApplicantAttachmentUrl(url));
  } catch (error: any) {
    yield put(
      setErrorApplicantAttachmentUrl({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleDownloadApplicantAttachment(action: { type: typeof downloadApplicantAttachment; payload: { remoteUuid: string; fileType: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestDownloadApplicantAttachment, currentUser.accessToken, action.payload.remoteUuid, action.payload.fileType, false);

    // download stream
    let fileName = 'attachment'; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: response.headers['content-type'] }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setDownloadApplicantAttachment());
  } catch (error: any) {
    yield put(
      setErrorDownloadApplicantAttachment({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

function* handleUpdateApplicationProperty(action: { type: typeof updateApplicationProperty; payload: { updateAppPropertyDto: UpdateApplicationPropertyDto; appUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    yield call(requestUpdateApplicationProperty, currentUser.accessToken, action.payload.appUuid, action.payload.updateAppPropertyDto);
    yield put(setUpdateApplicationProperty());
  } catch (error: any) {
    yield put(
      setErrorUpdateApplicationProperty({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleExportApplicationZip(action: any) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<Stream> = yield call(requestExportApplicationDetail, currentUser.accessToken, action.payload.AppUuid, action.payload.DesiredFileDto);

    // download stream
    let fileName = 'online_application.pdf'; // fallback
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }

    const url = URL.createObjectURL(new Blob([response.data as unknown as BlobPart], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);

    yield put(setExportApplicationZip());
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setErrorExportApplicationZip({ ...error?.response?.data }));
    } else {
      yield put(setErrorExportApplicationZip({ ...error }));
    }
  }
}

export function* applicationsSaga() {
  yield takeLatest(getFetchingApplicationsData.type, handleFetchingApplications);
  yield takeLatest(getFetchingApplicationsDataV2.type, handleFetchingApplicationsV2);
  yield takeLatest(changeApplicationStatus.type, handleChangeApplicationStatus);
  yield takeEvery(getApplicant.type, handleGetApplicant);
  yield takeEvery(getApplication.type, handleGetApplication);
  yield takeLatest(createApplicant.type, handleCreateApplicant);
  yield takeEvery(createScreeningOrder.type, handleCreateScreeningOrder);
  yield takeLatest(updateApplicant.type, handleUpdateApplicant);
  yield takeLatest(deleteApplicant.type, handleDeleteApplicant);
  yield takeLatest(createPet.type, handleCreatePet);
  yield takeLatest(updatePet.type, handleUpdatePet);
  yield takeLatest(deletePet.type, handleDeletePet);
  yield takeLatest(createVehicle.type, handleCreateVehicle);
  yield takeLatest(updateVehicle.type, handleUpdateVehicle);
  yield takeLatest(deleteVehicle.type, handleDeleteVehicle);
  yield takeLatest(createEmployment.type, handleCreateEmployment);
  yield takeLatest(updateEmployment.type, handleUpdateEmployment);
  yield takeLatest(deleteEmployment.type, handleDeleteEmployment);
  yield takeLatest(createRentalHistory.type, handleCreateRentalHistory);
  yield takeLatest(updateRentalHistory.type, handleUpdateRentalHistory);
  yield takeLatest(deleteRentalHistory.type, handleDeleteRentalHistory);
  yield takeLatest(getInvitedApplication.type, handleGetInvitedApplication);
  yield takeLatest(getCompanyContract.type, handleGetOrganizationContract);
  yield takeLatest(getExportApplicationDetails.type, handleExportApplicationDetails);
  yield takeLatest(getExportApplicationPdf.type, handleExportApplicationPdf);
  yield takeLatest(sendCoapplicantInvitation.type, handleSendCoapplicantInvitation);
  yield takeEvery(getScreeningOrderDetails.type, handleGetScreeningDetails);
  yield takeEvery(sendApplicationDecisionNotification.type, handleSendApplicationStatusNotification);
  yield takeEvery(downloadApplicationDecisionPdf.type, handleDownloadApplicationDecisionPdf);
  yield takeEvery(exportEmploymentRelease.type, handleExportEmploymentRelease);
  yield takeEvery(exportRentalRelease.type, handleExportRentalRelease);
  yield takeEvery(fetchEmploymentReleaseURL.type, handleFetchEmploymentReleaseURL);
  yield takeEvery(fetchRentalHistoryReleaseURL.type, handleFetchRentalHistoryReleaseURL);
  yield takeLatest(createApplicationNote.type, handleCreateApplicationNote);
  yield takeLatest(getAllApplicationNotes.type, handleGetAllApplicationNotes);
  yield takeLatest(deleteApplicationNote.type, handleDeleteApplicationNote);
  yield takeEvery(fetchApplicantAttachmentUrl.type, handleFetchApplicantAttachmentUrl);
  yield takeEvery(downloadApplicantAttachment.type, handleDownloadApplicantAttachment);
  yield takeLatest(updateApplicationProperty.type, handleUpdateApplicationProperty);
  yield takeLatest(exportApplicationZip, handleExportApplicationZip);
}
